import { DomainError } from '@dma/shared';

/**
 * Raised when a contact message submission violates a business/validation
 * rule. Follows the same pattern as `InvalidHeroContentError` in the Home
 * feature (see features/home/domain/errors) for consistency across features.
 */
export class InvalidContactMessageError extends DomainError {
  constructor(reason: string) {
    super('INVALID_CONTACT_MESSAGE', `Contact message is invalid: ${reason}`);
    this.name = 'InvalidContactMessageError';
    Object.setPrototypeOf(this, InvalidContactMessageError.prototype);
  }
}
